// import axios from "axios";
import React, { Component } from 'react';
import { post, get, getFreshToken } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
import '../adminDash.css';
import urls from '../../custom_libraries/urls';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import { Link } from 'react-router-dom';
import { Button, Box, Paper, Tooltip} from '@mui/material';
import passwordEye from '../../assets/icons8-eye-64.png';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#000000",
      // paper: "#121212",
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class AddUser extends Component {

  constructor(props) {
    super(props);
    this.state = {
      matches: [],
      content: '',

      user_type: 'TechnicianUser',
      user_name: '',
      tech_email: '',
      emailError: "",
      tech_password: '',
      conf_tech_pass: '',
      first_name: '',
      last_name: '',
      mob_num: '',
      dealer_email: '',
      dealer_passcode: '',
      user_passcode: "",
      gasspaging_speaker: "False",
      warning:false,
      warning1:false,
      warning2:false,
      warning3:false,
      warning4:false,
      warning5:false,
      Success:false,
      error:false,
      warning_email:false,
      responseMessage:'',
      passwordShown:false,
      confPasswordShown:false,
      open_progress_bar: false,
      groups_list: [],
      groupname:'',
      groupId:null,

    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    this.setState({ dealer_email : localStorage.getItem(globalVariables.USER_EMAIL)});
    this.getDealerInfo();
    // this.getGroupsList(); // uncomment this for grouping feature
  }

  validateSignedIn = async () => {
      try {
        let is_fresh_token = await getFreshToken();
        console.log("Fresh Token:", is_fresh_token);

        if (!is_fresh_token) {
          console.log("Navigating to login...");
          this.props.navigate("/");
          return;
        }
      } catch (error) {
        console.error("Error in validateSignedIn:", error);
      }
    }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.warning !== prevState.warning ||
        this.state.warning2 !== prevState.warning2 ||
        this.state.warning1 !== prevState.warning1 ||
        this.state.warning3 !== prevState.warning3 ||
        this.state.warning4 !== prevState.warning4 ||
        this.state.warning5 !== prevState.warning5 ||
        this.state.Success !== prevState.Success ||
        this.state.error !== prevState.error ||
        this.state.warning_email !== prevState.warning_email
    ) {
        if (
            this.state.warning ||
            this.state.error ||
            this.state.warning1 ||
            this.state.warning2 ||
            this.state.warning3 ||
            this.state.warning4 ||
            this.state.warning5 ||
            this.state.Success ||
            this.state.warning_email
        ) {
            setTimeout(() => {
                this.setState({
                    warning: false,
                    error: false,
                    warning1: false,
                    warning2: false,
                    warning3: false,
                    warning4: false,
                    warning5: false,
                    Success: false,
                    warning_email: false,
                });
            }, 2000); // 1 second
        }
    }
}

    getGroupsList = async () => {
      try {
        this.startLoading();
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
        }

        console.log("Fetching data from:", urls.GET_ALL_GROUPS); // Update URL for fetching sites
        const response = await get(urls.GET_ALL_GROUPS, headers);
        console.log("response getGroupsList ===> ", response);
        this.stopLoading();
        if (!response.data.groups) {
          console.error("Failed to fetch getGroupsList.");
          this.setState({ groups_list: [] });
          return;
        }

        this.setState({ groups_list: response.data.groups});
      } catch (error) {
        console.error("Error in getGroupsList:", error);
        this.setState({ groups_list: [] });
      }
    };

  // this function is no more used bz: it is not handling the exit/return form submission, it only gives alerts for mentioned conditions, hence merged this into main insertTechRegistrationInfo()
  // jsonData = () => {
  //   // this.setState({ dealer_email: localStorage.getItem(globalVariables.USER_EMAIL) });
  //   console.log("dealer_email in jsonData---------->", this.state.dealer_email);
  //   // mob no validation
  //   if (this.state.mob_num.length !== 10) {
  //     this.stopLoading();
  //     alert("Mobile number must be exactly 10 digits");
  //     return; // Prevent form submission
  //   }

  //   // Email format validation
  //   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //   if (!emailRegex.test(this.state.dealer_email)) {
  //       this.stopLoading();
  //       alert("Please enter a valid email address");
  //       return;
  //   }

  //   let data = {

  //     "user_type": 'CustomerUser',
  //     "username": this.state.user_name,
  //     "email": this.state.tech_email,
  //     "password1": this.state.tech_password,
  //     "password2": this.state.conf_tech_pass,
  //     "first_name": this.state.first_name,
  //     "last_name": this.state.last_name,
  //     "admin_email": this.state.dealer_email, //hardcoded data as of now
  //     "admin_passcode": this.state.dealer_passcode,  //hardcoded data as of now
  //     "is_staff": 0,
  //     "is_verified": false,
  //     "phoneno": this.state.mob_num,
  //     // "group_id": this.state.groupId,

  //   }
  //   console.log("-----JSON DATA -------->", data)
  //   return JSON.stringify(data)
  // }

  insertTechRegistrationInfo = async () => {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
    // let dealer_email = localStorage.getItem(globalVariables.DEALER_EMAIL)
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_tocken}`
    }

    if (this.state.mob_num && this.state.mob_num.length !== 10) {
      this.stopLoading();
      alert("Mobile number must be exactly 10 digits");
      return; // Prevent form submission
    }

    // Email format validation dealer
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.state.dealer_email)) {
        this.stopLoading();
        alert("Please enter a valid email address");
        return;
    }

    // Email format validation Technician
    if (this.state.tech_email && !emailRegex.test(this.state.tech_email)) {
        this.stopLoading();
        alert("Enter a valid User Email address.");
        return;
    }

    let data = {

      "user_type": 'CustomerUser',
      "username": this.state.user_name,
      "email": this.state.tech_email,
      "password1": this.state.tech_password,
      "password2": this.state.conf_tech_pass,
      "first_name": this.state.first_name,
      "last_name": this.state.last_name,
      "admin_email": this.state.dealer_email, //hardcoded data as of now
      "admin_passcode": this.state.dealer_passcode,  //hardcoded data as of now
      "is_staff": 0,
      "is_verified": false,
      "phoneno": this.state.mob_num,
      "user_passcode": this.state.user_passcode,
      "gasspaging_speaker": this.state.gasspaging_speaker
      // "group_id": this.state.groupId,

    }
    if (!this.state.user_passcode) {
      delete data.user_passcode;
    }
    console.log("-----JSON DATA -------->", data)
    // return JSON.stringify(data)

    let post_data = JSON.stringify(data);

    console.log("post_data in insertCreateTicketInfo---------->", post_data);

    // Parse the JSON string into an object
    let postDataObj = JSON.parse(post_data);

    for (const key in postDataObj) {
      // user_passcode is optional
      if (key === "user_passcode") continue;

      if (postDataObj[key] === null || postDataObj[key] === undefined || postDataObj[key] === "") {
        // alert("Please fill in all the required fields.");
        this.setState({warning:true})
        return;
      }
    }
    // let techName = this.state.user_name
    // if (techName.length > 15 ) {
    //   console.log("techname length ---->", techName.length);
    //   alert("User name is too long, enter maximun 15 characters");
    //   return
    //  }
    try {
      this.startLoading();
      let response = await post(urls.REGISTER, post_data, headers);
      this.stopLoading();

      console.log("============= successful insert registration info =======", response);

      // ✅ SUCCESS CASE
      if (response?.detail === "Verification e-mail sent." || response?.key) {
        this.setState({ Success: true });
        setTimeout(() => window.location.reload(), 1500);
        return;
      }

      //  NORMALIZE ALL ERRORS INTO AN ARRAY OF STRINGS
      let errors = [];

      if (Array.isArray(response)) {
        // Direct array like ["Wrong Admin Passcode."]----
        errors = response;
      } else if (typeof response === "object" && response !== null) {
        Object.entries(response).forEach(([field, value]) => {
          if (Array.isArray(value)) {
            value.forEach(v => {
              if (typeof v === "string") {
                errors.push(v);
              } else if (v?.message) {
                errors.push(v.message);
              }
            });
          } else if (typeof value === "string") { //safe side check
            errors.push(value);
          }
        });
      }

      console.log("Normalized errors:", errors);

      // MATCH ERRORS TO WARNINGS
      errors.forEach(err => {
        if (err.includes("username already exists")) {
          this.setState({ warning1: true });
        } else if (err.includes("password is too short")) {
          this.setState({ warning2: true });
        } else if (err.includes("didn't match")) {
          this.setState({ warning3: true });
        } else if (err.includes("User with this Email address already exists.")) {
          this.setState({ warning_email: true });
        } else if (err.includes("Wrong Admin Passcode")) {
          this.setState({ warning5: true });
        } else {
          this.setState({ error: true }); // fallback
        }
      });

    } catch (error) {
      this.stopLoading();
      this.setState({ error: true });
      console.error("Error in user Registration:", error);
    }

  }

 // ✅ Email validation function
validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

// ✅ Handle typing in email field
handleEmailChange = (field, value) => {
  this.setState({ [field]: value });

  if (value && !this.validateEmail(value)) {
    this.setState({ emailError: "User email is invalid" });
  } else {
    this.setState({ emailError: "" });
  }
};


  getDealerInfo = async () => {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
    let dealer_uuid = localStorage.getItem(globalVariables.USER_ID);
    let headers = {
      // 'content-type': 'application/json'
      'content-Type': 'application/json; charset=UTF-8',
      'Authorization': `Bearer ${access_tocken}`,
    }
    let response = await get(`${urls.BASE_URL}/api/users/dealer_user/${dealer_uuid}/`, headers)
    this.setState({ dealer_email: response.data?.[0].dealer_email });
  }

  togglePasswordVisiblity = () => {
    this.setState(prevState => ({
      passwordShown: !prevState.passwordShown
    }));
    };

  toggleConfirmPasswordVisiblity = () => {
    this.setState(prevState => ({
      confPasswordShown: !prevState.confPasswordShown
    }));
    };

  startLoading = () => {
    console.log("startloading")

    this.setState({ open_progress_bar: true })
  }

  stopLoading = () => {
      this.setState({ open_progress_bar: false })
  }

  render() {
    // let admin_email = localStorage.getItem(globalVariables.USER_EMAIL);
    const{warning, warning1,warning2,warning3,warning4,Success,error, warning5, passwordShown, confPasswordShown, warning_email, groupname, groups_list}=this.state

    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <style>{`
          @media (max-width: 768px) {
            .add-user-page {
              height: auto !important;
              min-height: 95vh;
              padding: 12px;
              padding-left: 60px
            }

            .add-user-page .add-user-form {
              box-sizing: border-box;
              width: 100%;
              margin: 0 !important;
              padding: 20px 16px;
            }

            .add-user-page .add-user-alert {
              box-sizing: border-box;
              width: 100% !important;
              margin: 0 0 16px !important;
            }

            .add-user-page .form-group {
              flex-direction: column;
              align-items: stretch;
              gap: 6px;
            }

            .add-user-page .form-group label {
              width: 100%;
              margin-right: 0;
              text-align: left;
            }

            .add-user-page .form-group > input,
            .add-user-page .form-group > select,
            .add-user-page .form-group > textarea,
            .add-user-page .form-group > div:not(.add-user-checkbox-row) {
              box-sizing: border-box;
              width: 100% !important;
              max-width: 100%;
            }

            .add-user-page .form-group > div:not(.add-user-checkbox-row) input {
              box-sizing: border-box;
              width: 100% !important;
              max-width: 100%;
            }

            .add-user-page .add-user-checkbox-row {
              flex-wrap: wrap;
            }

            .add-user-page .add-user-submit {
              box-sizing: border-box;
              width: 100% !important;
              height: auto !important;
              margin: 8px 0 10px !important;
            }

            .add-user-page .add-user-submit button {
              width: 100%;
            }
          }
        `}</style>
        <Box className="add-user-page" style={{height:"95vh"}}>

          <div className="bordered-div add-user-form" style={{ display: 'flex', flexDirection: 'column', marginLeft: '2.5%' }} >
            { warning ? (<Alert className="add-user-alert" severity="warning" style={{ marginLeft:'7.5%', width: "480px" }}>Please fill in all the required fields!</Alert>
              ) :warning1 ? (
                <Alert className="add-user-alert" severity="warning" style={{ marginLeft:'7%', width: "480px" }}>User name or email already exit! Verify.</Alert>
              ) :warning2 ? (
                <Alert className="add-user-alert" severity="warning" style={{ marginLeft:'7%', width: "480px" }}>password is too short! enter minimum 8 characters.</Alert>
              ) :warning3 ? (
                <Alert className="add-user-alert" severity="warning" style={{ marginLeft:'7%', width: "480px" }}>The two password fields didn't match!</Alert>
              ) :warning4 ? (
                <Alert className="add-user-alert" severity="warning" style={{ marginLeft:'7%', width: "480px" }}>Enter a valid email address!</Alert>
              ) :warning5 ? (
                <Alert className="add-user-alert" severity="warning" style={{ marginLeft:'7%', width: "480px" }}>Wrong Admin Passcode.!</Alert>
              ) :warning_email ? (
                <Alert className="add-user-alert" severity="warning" style={{ marginLeft:'7%', width: "480px" }}>User with this email already exists!</Alert>
              ):error ? (
                  <Alert className="add-user-alert" severity="error" style={{ marginLeft:'7%', width: "480px" }}>Server Error! New user was not registered!</Alert>
              ) :Success ? (
                  <Alert className="add-user-alert" icon={<CheckIcon fontSize="inherit" />} severity="success" style={{ marginLeft:'7%', width: "480px" }}>
                      "Great! The new user is now registered."
                  </Alert>
              ) : null}
            <div className='form-group'>
              <label htmlFor="user_name">User Role <span style={{ color: 'red', fontFamily: "Arial, sans-serif"}}>*</span> : &nbsp;</label>
              <input
                type="text"
                id="user_type"
                name="user_type"
                readonly
                style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif", cursor: 'not-allowed', color:'gray' }}
                // placeholder="Technician User"
                value={"Customer User"}
                // onChange={(evt) => this.setState({ user_type: evt.target.value })}
              />
              <Tooltip title="By default, the user role is set to 'Customer User'. You can update/edit the role afterwards from 'User List' tab."
                    placement="right"
                    arrow
                    componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#283348',
                        color: '#fff',
                        fontSize: '13px',
                        border: '1px solid #99acb8',
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#283348',
                      },
                    },
                }}
                  >
                  <InfoOutlinedIcon
                    style={{
                      fontSize: "22px",
                      marginLeft: "6px",
                      verticalAlign: "middle",
                      color: "#bac6d6",
                      cursor: "pointer"
                    }}
                  />
              </Tooltip>
            </div>
            <div className='form-group'>
              <label htmlFor="user_name">User name <span style={{ color: 'red', fontFamily: "Arial, sans-serif"}}>*</span> : &nbsp;</label>
              <input
                type="text"
                id="user_name"
                name="user_name"
                required
                style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}
                // placeholder=" fill upto 32 letters only (including spaces)"
                value={this.state.user_name}
                onChange={(evt) => this.setState({ user_name: evt.target.value })}
              />
            </div>


              <div className='form-group'>
                <label htmlFor="tech_email"> Email <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
                <div style={{ display: 'flex', flexDirection: 'column' }}>

                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}
                    value={this.state.tech_email}
                    onChange={(evt) => this.handleEmailChange("tech_email", evt.target.value)}
                  />

                  {/* Same style as mobile validation */}
                  {this.state.emailError && (
                    <p style={{ color: 'red', fontSize: '14px' }}>
                      {this.state.emailError}
                    </p>
                  )}

                </div>
              </div>

              <div className='form-group'>
                <label htmlFor="tech_password" > Password <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
                <div style={{ position: "relative", display: "inline-block", width: "350px" }}>
                  <input
                    type={passwordShown ? "text" : "password"}
                    id="password"
                    name="password"
                    required
                    style={{ width: '100%', height: '0.6cm', fontFamily: "Arial, sans-serif" }}

                    value={this.state.tech_password}
                    onChange={(evt) => this.setState({ tech_password: evt.target.value })}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "1px",
                      top: "55%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    {/* {showPassword ? <EyeOff size={16} /> : <Eye size={16} />} */}
                    <img onClick={this.togglePasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />

                  </span>
                </div>
              </div>

              <div className='form-group'>
                <label htmlFor="conf_tech_pass" > Confirm password <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
                <div style={{ position: "relative", display: "inline-block", width: "350px" }}>
                <input
                  type={confPasswordShown ? "text" : "password"}
                  id="conf_tech_pass"
                  name="conf_tech_pass"
                  required
                  style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}

                  value={this.state.conf_tech_pass}
                  onChange={(evt) => this.setState({ conf_tech_pass: evt.target.value })}
                />
                <span
                    style={{
                      position: "absolute",
                      right: "1px",
                      top: "55%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    <img onClick={this.toggleConfirmPasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />

                  </span>
                  </div>
              </div>

              <div className='form-group'>
                <label htmlFor="first_name"> First name <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
                <input
                  type="text"
                  id="first_name"
                  name="first_name"
                  required
                  style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}

                  value={this.state.first_name}
                  onChange={(evt) => this.setState({ first_name: evt.target.value })}
                />
              </div>

              <div className='form-group'>
                <label htmlFor="last_name" > Last name <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
                <input
                  type="text"
                  id="last_name"
                  name="last_name"
                  required
                  style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}

                  value={this.state.last_name}
                  onChange={(evt) => this.setState({ last_name: evt.target.value })}
                />
              </div>
              {/* uncomment this for grouping feature */}
              {/* <div className='form-group'>
                <label htmlFor="last_name" > Group name <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
                <select
                      name="groupname"
                      value={groupname}
                      // onChange={this.handleInputChange}
                      onChange={(evt) => this.setState({ groupname: evt.target.value })}
                      style={{ width: '355px', height: '0.85cm', fontFamily: "Arial, sans-serif", fontSize:'13px', color:'black' }}
                    >
                      <option value="" disabled>Select group for this user</option>
                      {groups_list.map((type) => (
                          <option key={type.id} value={type.id}>
                              {type.name}
                          </option>
                      ))}
                </select>
              </div> */}

              <div className='form-group'>
                <label htmlFor="mob_num" > Mobile no. <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
                <div style={{display:'flex', flexDirection:'column'}}>
                <input
                  type="tel"
                  id="mob_num"
                  name="mob_num"
                  required
                  style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}
                  value={this.state.mob_num}
                  // onChange={(evt) => this.setState({ mob_num: evt.target.value })}
                  onChange={(evt) => {
                    const value = evt.target.value.replace(/\D/g, ""); // Only allow numbers
                    if (value.length <= 10) {
                      this.setState({ mob_num: value });
                    }
                  }}
                />
                {this.state.mob_num.length > 0 && this.state.mob_num.length !== 10 && (
                  <p style={{ color: 'red', fontSize:'14px' }}>Mobile number must be exactly 10 digits</p>
                )}
                </div>
              </div>

              <div className='form-group'>
                  <label htmlFor="dealer_email" > Admin email <span style={{color:'red', fontFamily: "Arial, sans-serif"}}>*</span> : &nbsp;</label>
                  <input
                      type="email"
                      id="dealer_email"
                      name="dealer_email"
                      required
                      style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif", backgroundColor:'#f2f4f7ff', color:'gray', cursor:'not-allowed' }}
                      readOnly
                      value={this.state.dealer_email}
                    />
              </div>

              <div className='form-group'>
                  <label htmlFor="dealer_passcode" > Admin passcode <span style={{color:'red',  fontFamily: "Arial, sans-serif"}}>*</span> : &nbsp;</label>
                  <input
                      type="text"
                      id="dealer_passcode"
                      name="dealer_passcode"
                      required
                      style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}

                      value={this.state.dealer_passcode}
                      onChange={(evt) => this.setState({ dealer_passcode: evt.target.value })}
                    />
              </div>
              <div className='form-group'>
                <label htmlFor="user_passcode">
                  Operator passkey : &nbsp;
                </label>

                <input
                  type="text"
                  id="user_passcode"
                  name="user_passcode"
                  style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}
                  value={this.state.user_passcode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 8) {
                      this.setState({ user_passcode: value });
                    }
                  }}
                />
              </div>
              <div className='form-group'>
                <label>
                  Allow Speaker/Mic Permission and view business details?
                  : &nbsp;
                </label>

                <div className="add-user-checkbox-row" style={{ display:'flex', alignItems:'center' }}>

                  <input
                    type="checkbox"
                    checked={this.state.gasspaging_speaker === "True"}
                    onChange={(e) =>
                      this.setState({
                        gasspaging_speaker: e.target.checked ? "True" : "False"
                      })
                    }
                    style={{ width:'25px', height:'25px', marginRight:'8px', cursor:'pointer' }}
                  />
                  <Tooltip title="If enabled, the user can use speaker/microphone operation, voice chat features and can view business details in the 'Alert' section. Recommended only for trusted users as it grants access to sensitive functionalities."
                    placement="right"
                    arrow
                    componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#283348',
                        color: '#fff',
                        fontSize: '13px',
                        border: '1px solid #99acb8',
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#283348',
                      },
                    },
                }}
                  >
                  <InfoOutlinedIcon
                    style={{
                      fontSize: "22px",
                      marginLeft: "6px",
                      verticalAlign: "middle",
                      color: "#bac6d6",
                      cursor: "pointer"
                    }}
                  />
                  </Tooltip>

                  {/* <span>
                    Allow (Speaker and Voice Chat)?
                  </span> */}

                </div>
              </div>

              <div className="add-user-submit" style={{ width: '130px', height: '0.5cm', marginLeft:'480px', marginTop: '8px', marginBottom: '10px' }}>
            <Button id="rowsPerPageButton"
              onClick={this.insertTechRegistrationInfo}
            > Add User</Button>
          </div>
              </div>




              {/* <div id="copyright-footer">
                <p style={{ fontSize: '12px' }}>
                  <em>&copy; 2024 Neudeep Technologies. All rights reserved.</em>
                </p>
              </div> */}
              {/* </div> */}

          {/* Backdrop with Circular Progress */}
          <Backdrop open={this.state.open_progress_bar}>
            <div className="custom-spinner">
                <div className="circle"></div>
                <div className="circle tilted"></div>
                <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
            </div>
          </Backdrop>
        </Box>
      </ThemeProvider>

    );
  }
}


export default AddUser;
